import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingSpinner from '../components/layout/LoadingSpinner';

const BuildrLabActivity = () => {
    const [labUrl, setLabUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const lab_url = queryParams.get('lab');

        if (lab_url) {
            setLabUrl(lab_url);
        }
    }, [location.search]);

    const handleLoad = () => {
        setIsLoading(false);
    };

    return (
        <div className="w-full h-full">
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                    <LoadingSpinner />
                </div>
            )}
            <iframe
                className="content-iframe w-full h-full transition-opacity duration-500 ease-in-out"
                title="Lab"
                src={labUrl}
                onLoad={handleLoad}
                style={{ opacity: isLoading ? 0 : 1 }}
                allow="microphone"
            ></iframe>
        </div>
    );
};

export default BuildrLabActivity;
